import {Component, ContentChildren, forwardRef, Injector, QueryList} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {SelectInputOptionComponent} from './select-input-options/select-input-option/select-input-option.component';
import {AbstractInput} from '../abstract-input';

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectInputComponent)
        }
    ],
    selector: 'vui-select-input',
    templateUrl: './select-input.component.html',
    styleUrls: ['./select-input.component.scss']
})
export class SelectInputComponent extends AbstractInput {
    public opened: boolean;
    @ContentChildren(SelectInputOptionComponent, {descendants: true}) public selectInputOptions: QueryList<SelectInputOptionComponent>;

    constructor(protected injector: Injector) {
        super(injector);
        this.selectInputOptions = new QueryList<SelectInputOptionComponent>();
        this.selectInputOptions.changes.subscribe(() => {
            this.check();
        });
    }

    public check(): void {
        if (this.match(this.value)) {
        } else {
            this.value = '';
        }
    }

    /**
     * Stringify and compare values to determine equality
     * @param value
     * @param comparison
     */
    public compare(value: any, comparison: any): boolean {
        return JSON.stringify(value) === JSON.stringify(comparison);
    }

    /**
     * Check if the provided value matches any of the available options
     */
    public match(value: any): boolean {
        return this.selectInputOptions.toArray().filter((selectInputOption) => this.compare(value, selectInputOption.value)).length > 0;
    }

    /**
     * Return the private member that holds
     * the current model value
     */
    public get value(): any {
        return this._value;
    }

    /**
     * Set the model value if it is not the same
     * as it currently is, also register a change
     * @param value
     */
    public set value(value: any) {
        if (value) {
            if (value !== this._value) {
                this._value = value;
                this.changed(this._value);
            }
        } else {
            this._value = '';
        }
    }
}
